/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypememorygrid3Inputs */

const zh_learn_mistakestypememorygrid3 = /** @type {(inputs: Learn_Mistakestypememorygrid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`记忆方格`)
};

const en_learn_mistakestypememorygrid3 = /** @type {(inputs: Learn_Mistakestypememorygrid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memory Grid`)
};

const es_learn_mistakestypememorygrid3 = /** @type {(inputs: Learn_Mistakestypememorygrid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuadrícula de memoria`)
};

/**
* | output |
* | --- |
* | "Memory Grid" |
*
* @param {Learn_Mistakestypememorygrid3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypememorygrid3 = /** @type {((inputs?: Learn_Mistakestypememorygrid3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypememorygrid3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypememorygrid3(inputs)
	if (locale === "en") return en_learn_mistakestypememorygrid3(inputs)
	return es_learn_mistakestypememorygrid3(inputs)
});
export { learn_mistakestypememorygrid3 as "learn_mistakesTypeMemoryGrid" }